import { GetApiUserError, GetApiUserVariables, RequestError, UserType, useGetUser as useGetApiUser } from '@sit/client-shared';
import { UseQueryOptions } from '@tanstack/react-query';

const variables = {
  requestConfig: {
    skipToast: (error: RequestError) => error.status === 401 || error.status === 403,
  },
} satisfies GetApiUserVariables;

export function useGetUser<TData = UserType>(
  options?: Omit<UseQueryOptions<UserType, GetApiUserError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) {
  // The deprecation warning is meant to signify to other hooks and components to use this hook instead.
  return useGetApiUser<TData>(variables, options);
}
